"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var slideout_1 = __importDefault(require("../helpers/slideout"));
var template_1 = __importDefault(require("../helpers/template"));
var log_1 = __importDefault(require("../helpers/log"));
var quantity_1 = __importDefault(require("./quantity"));
var utilities_1 = require("../helpers/utilities");
var btnCheckout_1 = __importDefault(require("./btnCheckout"));
var cart_1 = __importDefault(require("../helpers/cart"));
var lazyLoader_1 = __importDefault(require("./lazyLoader"));
var MiniBasket = /** @class */ (function () {
    function MiniBasket() {
        var _this = this;
        this.reinit = (0, utilities_1.debounce)(function () {
            if (_this.node) {
                slideout_1.default.destroy(_this.slideout);
                _this.slideout = _this.getSlideoutByDevice();
                _this.load();
            }
        }, 250);
        this.config = {
            desktopWidth: 400,
            miniBasket: '[data-mini-basket]',
            view: 'ajax-mini-basket',
            loadingClassName: 'mini-basket--loading',
            selectors: {
                item: '[data-mini-basket-item]',
                remove: '[data-mini-basket-remove-btn]',
                title: '[data-mini-basket-title]',
                open: '[data-mini-basket-open-btn]',
                close: '[data-mini-basket-close-btn]',
                content: '[data-mini-basket-content]'
            }
        };
    }
    MiniBasket.prototype.init = function () {
        this.node = document.querySelector(this.config.miniBasket);
        if (!this.node)
            return;
        this.slideout = this.getSlideoutByDevice();
        this.load();
    };
    MiniBasket.prototype.getSlideoutByDevice = function () {
        if ((0, utilities_1.isDesktop)()) {
            return this.slideout = slideout_1.default.init(this.node, {
                side: 'right',
                padding: this.config.desktopWidth,
            });
        }
        return slideout_1.default.init(this.node, {
            side: 'right'
        });
    };
    MiniBasket.prototype.load = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.update();
                return [2 /*return*/];
            });
        });
    };
    MiniBasket.prototype.update = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, template_1.default.getAndUpdateHTML({
                                node: this.node,
                                content: this.config.selectors.content,
                                url: '/pages/mini-basket'
                            })];
                    case 1:
                        _a.sent();
                        document.querySelectorAll(this.config.selectors.remove).forEach(function (htmlElement) {
                            htmlElement.addEventListener('click', _this.handleRemoveClick.bind(_this));
                        });
                        document.querySelectorAll(this.config.selectors.open).forEach(function (htmlElement) {
                            htmlElement.addEventListener('click', _this.slideout.open.bind(_this.slideout));
                        });
                        document.querySelectorAll(this.config.selectors.close).forEach(function (htmlElement) {
                            htmlElement.addEventListener('click', _this.slideout.close.bind(_this.slideout));
                        });
                        this.updateItemAmount();
                        quantity_1.default.init();
                        btnCheckout_1.default.init();
                        lazyLoader_1.default.update();
                        btnCheckout_1.default.loaded();
                        // @ts-ignore
                        if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                            // @ts-ignore
                            typeof BOLD.common.eventEmitter.emit === 'function') {
                            // @ts-ignore
                            BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        log_1.default.error(error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MiniBasket.prototype.updateItemAmount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, itemCount_1, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, cart_1.default.get()];
                    case 1:
                        data = _a.sent();
                        itemCount_1 = data.data.item_count;
                        if (itemCount_1 > 0)
                            document.querySelectorAll('[data-mini-basket-items-amount]').forEach(function (htmlElement) { return htmlElement.innerHTML = itemCount_1; });
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        log_1.default.error(error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MiniBasket.prototype.open = function (event) {
        event.preventDefault();
        this.slideout.open();
    };
    MiniBasket.prototype.close = function (event) {
        event.preventDefault();
        this.slideout.close();
    };
    MiniBasket.prototype.handleRemoveClick = function (event) {
        event.preventDefault();
        var target = event.target;
        if (target && target.dataset.variantId)
            this.remove(target.dataset.variantId);
    };
    MiniBasket.prototype.remove = function (variantId) {
        return __awaiter(this, void 0, void 0, function () {
            var variantIdInt, updates, error_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        btnCheckout_1.default.loading();
                        variantIdInt = parseInt(variantId);
                        updates = {};
                        updates[variantIdInt] = 0;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, cart_1.default.update({
                                updates: updates
                            })];
                    case 2:
                        _a.sent();
                        this.update();
                        return [3 /*break*/, 4];
                    case 3:
                        error_3 = _a.sent();
                        log_1.default.error(error_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return MiniBasket;
}());
exports.default = new MiniBasket();
